
global.InterestMonthYearAstrid = (function ($) {

	function init(data) {
		const form = document.getElementById('riksbank-seriesform');
		const calculationMethodElement = document.getElementById("js-calculation-methods");
		const monthSelectWrapper = document.getElementById("month-select");
		const aggregateRadioButtons = document.querySelectorAll('input[type="radio"][name="a"]');
		const yearDropdown = document.getElementById('y');
		const monthDropdown = document.getElementById('m');
		const submitFormBtn = document.getElementById('submit');
		const formError = document.getElementById('form-error');

		if (calculationMethodElement) { // 1st step
			showDomElement(calculationMethodElement, true);
		}

		if (aggregateRadioButtons && monthSelectWrapper) {
			handleAggregationRadioButtons();

			aggregateRadioButtons.forEach(function (radioButton) {
				radioButton.addEventListener('change', function (event) {
					handleAggregationRadioButtons();
					yearDropdown.value = yearDropdown.options[0].value;
					monthDropdown.value = monthDropdown.options[0].value;
				});
			});
		}

		if (yearDropdown) {
			yearDropdown.addEventListener('change', function (event) {
				// Hide current and future months if current year is selected
				if (yearDropdown.value === yearDropdown.options[1].value) {
					hideCurrentAndFutureMonths();
				} else {
					for (var i = 0; i < monthDropdown.options.length; i++) {
						var option = monthDropdown.options[i];
						option.style = '';
					}
				}
			});
		}

		function handleAggregationRadioButtons() {
			if (aggregateRadioButtons[0].checked) {
				handleYearlyAggregation();
			}

			if (aggregateRadioButtons[1].checked) {
				handleMonthlyAggregation();
			}
		}

		function handleYearlyAggregation() {
			if (yearDropdown && yearDropdown.options[1].getAttribute('data-disabled') !== null) {
				yearDropdown.options[1].style.display = 'none';
			}

			for (var i = 0; i < monthDropdown.options.length; i++) {
				var option = monthDropdown.options[i];
				option.style = '';
			}

			monthDropdown.removeAttribute('required');
			showDomElement(monthSelectWrapper, false);
		}

		function handleMonthlyAggregation() {
			yearDropdown.options[1].style.display = '';

			if (yearDropdown.value === new Date().getFullYear().toString()) {
				hideCurrentAndFutureMonths();
			} else {
				for (var i = 0; i < monthDropdown.options.length; i++) {
					var option = monthDropdown.options[i];
					option.style = '';
				}
			}

			monthDropdown.setAttribute('required', '');
			showDomElement(monthSelectWrapper, true);
		}

		function hideCurrentAndFutureMonths() {
			for (var i = 1; i < monthDropdown.options.length; i++) {
				let selectedMonth = monthDropdown.value;
				let option = monthDropdown.options[i];

				if (option.getAttribute('data-disabled') !== null) {
					option.style.display = 'none';

					if (selectedMonth === option.value) {
						monthDropdown.value = monthDropdown.options[0].value;
					}
				}
			}
		}

		function showDomElement(e, state) {
			if(state === true) {
				e.classList.remove("visually-hidden");
				e.ariaHidden = "false"
			} else {
				e.classList.add("visually-hidden");
				e.ariaHidden = "true"
			}
		}

		if (form) {
			form.onclick = function (event) {
				let target = event.target;
				let selection = target.value; // set value to look for as classname
				let rangeValue = document.querySelector('input[name="a"]:checked').value;
				let checkboxes = document.getElementsByClassName(selection); // find all checkboxes by selection for toggle-all
				let ckbChecked = document.querySelectorAll('input[type="checkbox"]:checked')
				let isAnyCkbChecked = (ckbChecked.length > 0) ? true : false;
				showDomElement(formError, false);

				for (let checkbox of checkboxes) {
					checkbox.checked = target.checked;
				}

				if(event.target.dataset.group && event.target.dataset.description != "toggle-all") {
					let checkedGroup = event.target.dataset.group;
					document.getElementById('toggle_' + checkedGroup).checked = false;
				}

				let freqDay = document.getElementById('D');
				let calculationMethods = document.getElementsByClassName("js-calculation-method");
				let average = document.getElementById('Average');

				if (freqDay) {
					if (freqDay && freqDay.checked) {
						for (let calculationMethod of calculationMethods) {
							calculationMethod.disabled = true;
							calculationMethod.checked = false;
						}
						average.checked = true;
					} else {
						for (let calculationMethod of calculationMethods) {
							calculationMethod.disabled = false;
						}
						average.checked = true;
						average.disabled = true;
					}
				}

				if (submitFormBtn && event.target.id.toString() === "submit") {

					if (rangeValue === "Y") {
						if(yearDropdown.selectedIndex !== 0 && isAnyCkbChecked) {
							return true;
						}
					}

					if (rangeValue === "M") {
						if(yearDropdown.selectedIndex !== 0) {
							if(monthDropdown.selectedIndex !== 0 && isAnyCkbChecked) {
								return true;
							}
						}
					}

					event.preventDefault();
					showDomElement(formError, true);
					formError.scrollIntoView({ behavior: "smooth", block: "center", inline: "center" });
				}
			}
		} // Form end

		const separator = document.getElementById("separator");
		if (separator) {
			separator.addEventListener('click', function (event) {
				if (event.target && event.target.matches("input[type='radio']")) {
					let val = event.target.value;
					setSeparator(val);
					setDownloadLink(val)
				}
			});

			let dlLinks = document.querySelectorAll(".dl_link a");
			let cells = document.querySelectorAll(".swea-table td.res span.sep");

			function setDownloadLink(val) {
				for (let dlLink of dlLinks) {
					let getLink = dlLink.getAttribute("href");
					const newLink = val === "Dot" ? getLink.replace('Comma', 'Dot') : getLink.replace('Dot', 'Comma');
					dlLink.setAttribute("href", newLink);
				}
			}

			function setSeparator(val) {
				for (let cell of cells) {
					const separator = val === "Dot" ? "." : ",";
					cell.innerHTML = separator.toString();
				}
			}
		}

    }

	return {
		init: init
	};

})(jQuery);
